export default function adPodsEnabled() {
  const ADPODS_EXLUDE = ['games.gameshownetwork.com', 'play.dictionary.com', 'puzzles.independent.co.uk', 'puzzles.standard.co.uk', 'elpais.arkadiumarena.com', 'juegos.elpais.com'];
  return !ADPODS_EXLUDE.includes(location.hostname);
}
